import { ThunkDispatch } from "redux-thunk";
import { GlobalState } from "../types";
import { useDispatch as useDispatchGeneric } from 'react-redux';
import {Action} from 'redux'
const useDispatch: () => ThunkDispatch<GlobalState, any, Action> = useDispatchGeneric;

export default useDispatch;
